module.exports = __webpack_public_path__ + "img/button_sign_up.2b94f29a.png";